import AjaxUtils from "../../util/ajax_utils";

export const ApckAssetBulkTable = {
    props: {
        src: {
           type: String,
           default: null
        }
    },
    data: function() {
        return {
            cols: [{
                'ctype': 'checkboxcolumn',
                'heading': ' ',
                'data': 'check',
                'width': 51,
                'hidden': false,
                'canHide': false,
                'falseValue': null
            },{
                'ctype': 'datecolumn',
                'heading': 'Created',
                'data': 'created',
                'canSearch': true,
                'width': 140,
                'hidden': true
            }, {
                'heading': 'Asset',
                'data': 'name',
                'hidden': false,
                'canHide': false,
                'canSearch': true
            }, {
                'heading': 'Description',
                'data': 'description',
                'canSearch': true
            }, {
                'ctype': 'boolcolumn',
                'heading': 'Application',
                'data': 'application',
                'center': true,
                'width': 100,
                'filters': true
            }, {
                'ctype': 'boolcolumn',
                'heading': 'In Scope',
                'data': 'scope',
                'center': true,
                'width': 80,
                'filters': true
            }],
            actions: [{
                title: "Copy asset",
                icon: "fa-clipboard",
                class: "btn-secondary",
                handler: this.copy
            },{
                title: "Edit asset",
                icon: "fa-pencil",
                class: "btn-secondary",
                handler: this.edit
            },{
                title: "Delete asset",
                icon: "fa-trash",
                class: "btn-negative",
                handler: this.delete
            }]
        };
    },
    methods: {
        edit: function(row) {
            var url = '/asset/edit/' + row.get('_id');
            window.location.href = url;
        },
        delete: function(row) {
            var me = this;
            window.app.confirm('Are you sure you want to delete this asset?', 'Delete Asset', function() {
                if (me.table && me.table.mask) {
                    me.table.mask.show();
                }
                var url = '/asset/edit/' + row.get('_id');
                $.post(url, {remove: 'true'}, function(_){
                    me.$refs.table.store.load(me.$refs.table.store.lastParams);
                });
            });
        },
        copy: function(row) {
            navigator.clipboard.writeText(row.get('name'));
        },
        copyAll: function(event, ...props) {
            window.requestVulnerabilityReport('/asset/csv');
        },
        bulkDelete: function(event, ...props) {
            var table = this.$refs.table;
            if (table.selectedRows !== undefined && table.selectedRows.length > 0) {
                var ids = table.selectedRows.join(',');
                window.app.confirm('Are you sure you want to delete ' + table.selectedRows.length + ' assets?', 'Delete Assets', function() {
                    if (table && table.mask) {
                        table.mask.show();
                    }
                    var url = '/asset/delete';
                    $.post(url, {ids: ids}, function(_){
                        table.store.load(table.store.lastParams);
                    });
                });
            }
        },
    },
    template: `
        <apck-table
            title="Assets"
            ref="table"
            :columns="cols"
            :src="src"
            :actions="actions"
            :actionBtnWidth="38"
        >
            <template v-slot:bbar>
                <apck-sep />
                <apck-button icon="fa-file-excel-o" :handler="copyAll" title="Export Assets" value="CSV Report" />
                <apck-sep />
                <apck-button icon="fa-trash" :handler="bulkDelete" title="Delete selected Assets" value="Delete selected Assets" />
            </template>
        </apck-table>
    `
}
